var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgOperationalForecastPassengers = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32,
  fill: "none",
  viewBox: "0 0 32 32"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M9.6 28H6.755V15.2H9.6v1.422h1.422V15.2h2.845V28h-2.845v-7.111H9.6zM10.311 3.822a2.08 2.08 0 0 1 1.499.617q.634.617.634 1.49 0 .875-.635 1.517-.634.643-1.498.643t-1.498-.643a2.09 2.09 0 0 1-.635-1.516q0-.875.635-1.49a2.08 2.08 0 0 1 1.498-.618",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M6.755 9.511h7.112c.785 0 1.422.637 1.422 1.422v7.111H5.333v-7.11c0-.786.637-1.423 1.422-1.423M20.978 28h-2.845V15.2h2.845v1.422H22.4V15.2h2.844V28H22.4v-7.111h-1.422zM21.689 3.822q.864 0 1.498.617.636.617.635 1.49 0 .875-.635 1.517-.634.643-1.498.643t-1.498-.643a2.09 2.09 0 0 1-.635-1.516q0-.875.635-1.49a2.08 2.08 0 0 1 1.498-.618",
  clipRule: "evenodd"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M18.133 9.511h7.111c.786 0 1.423.637 1.423 1.422v7.111H16.71v-7.11c0-.786.637-1.423 1.422-1.423",
  clipRule: "evenodd"
})));
export default SvgOperationalForecastPassengers;